import React from "react";
import App from "./app";
import { BrowserRouter as Router } from "react-router-dom";
import "./main.css";
import "./index.css";
import "./font-inter.css";
import { createRoot } from "react-dom/client";

import { initSentry } from "./services/sentry";
import { initGA4 } from "./services/ga4";
import { storeSignupRefFromUrl } from "./services/signup-attribution";

import { NotificationProvider } from "./context/notification-context";
import { TimezoneProvider } from "./context/timezone-context";
import { FullscreenProvider } from "./context/fullscreen-context";
import { Supergrow2Provider } from "./context/supergrow2-context";
import NiceModel from "@ebay/nice-modal-react";
import * as Tooltip from "@radix-ui/react-tooltip";
import { PostHogProvider } from 'posthog-js/react'
import { initAssetVersionChecker } from "./utils/asset-version-checker";

const options = {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  defaults: '2025-05-24',
}

initSentry();
initGA4();
storeSignupRefFromUrl();

const container = document.getElementById("root");
createRoot(container).render(
  <Router>
    <PostHogProvider apiKey={import.meta.env.VITE_POSTHOG_KEY} options={options}>
      <TimezoneProvider>
        <NotificationProvider>
          <FullscreenProvider>
            <Supergrow2Provider>
              <NiceModel.Provider>
                <Tooltip.Provider delayDuration={300}>
                  <App />
                </Tooltip.Provider>
              </NiceModel.Provider>
            </Supergrow2Provider>
          </FullscreenProvider>
        </NotificationProvider>
      </TimezoneProvider>
    </PostHogProvider>
  </Router>
);

// Initialize runtime asset version checker
// This detects when a new deployment has occurred and reloads the page
// to ensure users are always running the latest version
//
// In development, call window.__testUpdateNotification() to preview the banner.
initAssetVersionChecker({
  checkInterval: 300000, // Check every 5 minutes
  enabled: import.meta.env.PROD || import.meta.env.VITE_ENABLE_VERSION_CHECKER === 'true',
});
